import { LOCALE_TAGS, type Locale } from '@360face/domain';

/** 'qui., 21 out.' / 'Thu 21 Oct' for a YYYY-MM-DD local date. */
export function formatDay(isoDate: string, locale: Locale): string {
  const [y, mo, d] = isoDate.split('-').map(Number);
  return new Intl.DateTimeFormat(LOCALE_TAGS[locale], {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(y!, mo! - 1, d!)));
}

/** 'Terça-feira, 3 de novembro' / 'Tuesday, 3 November' for a YYYY-MM-DD local date. */
export function formatDayLong(isoDate: string, locale: Locale): string {
  const [y, mo, d] = isoDate.split('-').map(Number);
  const text = new Intl.DateTimeFormat(LOCALE_TAGS[locale], {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(y!, mo! - 1, d!)));
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** "HH:MM" of a local wall-clock start plus minutes (the offset in `start` is kept as is). */
export function endTime(start: string, minutes: number): string {
  const [h, mm] = start.slice(11, 16).split(':').map(Number);
  const total = (h! * 60 + mm! + minutes) % (24 * 60);
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}
